import { render, staticRenderFns } from "./loading-spinner.vue?vue&type=template&id=06741208&scoped=true&"
import script from "./loading-spinner.vue?vue&type=script&lang=js&"
export * from "./loading-spinner.vue?vue&type=script&lang=js&"
import style0 from "./loading-spinner.vue?vue&type=style&index=0&id=06741208&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06741208",
  null
  
)

export default component.exports